import { createClass } from '@/modules/classBuilder/classBuilder'
import { ClassType } from '@/modules/classBuilder/mixins/base'
import { CastType } from '../../../types/casts'
import { CastBase } from './CastBase'


export const CastPlain = createClass(CastBase)
                            .addCastType(CastType.Plain)
                            .addCasters()
                            .addOnlineSessions()
                            .addCustomOutputs()
                            .addPresets()
                            .addInputs()
                            .addMutes({ useCastLevelMutes: false })
                            .get()

export type CastPlain = ClassType<typeof CastPlain>
